export enum OrderStatusEnum {
	NEW = 1,
	SCHEDULED,
	PENDING_EXECUTION,
	IN_PROGRESS,
	MODIFIED,
	COMPLETED,
	CANCELLED,
}